var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocalTime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.966,
    height: 64,
    viewBox: "0 0 62.966 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#cedbfc}.cls-2{fill:#f0b33f}.cls-3{fill:#002173}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "time",
    transform: "translate(-13.971 -9.996)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12816",
    "data-name": "Group 12816",
    transform: "translate(13.977 9.996)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15948",
    d: "M19.216 24.939a14.967 14.967 0 0 1 12.341-14.716 14.943 14.943 0 1 0 0 29.431 14.967 14.967 0 0 1-12.341-14.715z",
    className: "cls-1",
    "data-name": "Path 15948",
    transform: "translate(-14.019 -9.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15949",
    d: "M273.528 24.939a14.967 14.967 0 0 1 12.341-14.715 14.943 14.943 0 1 0 0 29.431 14.967 14.967 0 0 1-12.341-14.715z",
    className: "cls-1",
    "data-name": "Path 15949",
    transform: "translate(-235.25 -9.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15950",
    d: "M273.528 287.193a14.967 14.967 0 0 1 12.341-14.715 14.943 14.943 0 1 0 0 29.431 14.967 14.967 0 0 1-12.341-14.715z",
    className: "cls-1",
    "data-name": "Path 15950",
    transform: "translate(-235.25 -238.136)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15951",
    d: "M19.216 287.193a14.967 14.967 0 0 1 12.341-14.715 14.943 14.943 0 1 0 0 29.431 14.967 14.967 0 0 1-12.341-14.715z",
    className: "cls-1",
    "data-name": "Path 15951",
    transform: "translate(-14.019 -238.136)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_15952",
    d: "M43.856 24.943a14.943 14.943 0 1 0-14.942 14.942 14.943 14.943 0 0 0 14.942-14.942zm-28.3.78h.817a.78.78 0 1 0 0-1.561h-.817a13.4 13.4 0 0 1 12.577-12.578v.816a.78.78 0 1 0 1.561 0v-.817a13.4 13.4 0 0 1 12.578 12.579h-.817a.78.78 0 0 0 0 1.561h.817A13.4 13.4 0 0 1 29.694 38.3v-.817a.78.78 0 1 0-1.561 0v.817a13.4 13.4 0 0 1-12.578-12.577z",
    className: "cls-2",
    "data-name": "Path 15952",
    transform: "translate(0 -.004)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15953",
    d: "M123.624 66.655h5.176a.78.78 0 0 0 0-1.561h-4.4v-7.262a.78.78 0 0 0-1.561 0v8.042a.78.78 0 0 0 .785.781z",
    className: "cls-2",
    "data-name": "Path 15953",
    transform: "translate(-94.711 -40.935)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15954",
    d: "M283.226 272.254a14.943 14.943 0 1 0 14.942 14.946 14.943 14.943 0 0 0-14.942-14.946zm.78 28.3v-.817a.78.78 0 1 0-1.561 0v.817a13.4 13.4 0 0 1-12.578-12.578h.817a.78.78 0 0 0 0-1.561h-.817a13.4 13.4 0 0 1 12.578-12.578v.817a.78.78 0 1 0 1.561 0v-.817a13.4 13.4 0 0 1 12.578 12.578h-.817a.78.78 0 1 0 0 1.561h.817a13.4 13.4 0 0 1-12.578 12.578z",
    className: "cls-2",
    "data-name": "Path 15954",
    transform: "translate(-221.231 -228.144)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15955",
    d: "M329.333 339.525l-5.173 4.62-7.521-6.535a.78.78 0 0 0-1.024 1.178l8.04 6.986a.78.78 0 0 0 1.032-.007l5.686-5.078a.78.78 0 1 0-1.04-1.164z",
    className: "cls-2",
    "data-name": "Path 15955",
    transform: "translate(-262.173 -284.832)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15956",
    d: "M283.226 10a14.943 14.943 0 1 0 14.943 14.943A14.943 14.943 0 0 0 283.226 10zm.78 28.3v-.817a.78.78 0 1 0-1.561 0v.817a13.4 13.4 0 0 1-12.578-12.578h.817a.78.78 0 0 0 0-1.561h-.817a13.4 13.4 0 0 1 12.578-12.578v.817a.78.78 0 1 0 1.561 0v-.817a13.4 13.4 0 0 1 12.578 12.578h-.817a.78.78 0 1 0 0 1.561h.817A13.4 13.4 0 0 1 284.006 38.3z",
    className: "cls-3",
    "data-name": "Path 15956",
    transform: "translate(-221.231 -.004)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15957",
    d: "M383.19 89.96l-5.69 3.778a.781.781 0 0 0-.2 1.11l5.179 7.107a.781.781 0 1 0 1.262-.919l-4.7-6.449 5.007-3.327a.78.78 0 1 0-.864-1.3z",
    className: "cls-3",
    "data-name": "Path 15957",
    transform: "translate(-315.942 -69.449)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15958",
    d: "M28.914 272.254A14.943 14.943 0 1 0 43.856 287.2a14.943 14.943 0 0 0-14.942-14.946zm.78 28.3v-.817a.78.78 0 1 0-1.561 0v.817a13.4 13.4 0 0 1-12.578-12.578h.817a.78.78 0 0 0 0-1.561h-.817a13.4 13.4 0 0 1 12.578-12.578v.817a.78.78 0 1 0 1.561 0v-.817a13.4 13.4 0 0 1 12.578 12.578h-.817a.78.78 0 0 0 0 1.561h.817a13.4 13.4 0 0 1-12.578 12.579z",
    className: "cls-3",
    "data-name": "Path 15958",
    transform: "translate(0 -228.144)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15959",
    d: "M69.523 330.443a.78.78 0 1 0-1.064 1.142l6.859 6.389v6.768a.78.78 0 1 0 1.561 0v-7.107a.781.781 0 0 0-.249-.571z",
    className: "cls-3",
    "data-name": "Path 15959",
    transform: "translate(-47.184 -278.582)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalTime);
export default __webpack_public_path__ + "static/media/local_time.ab3429cfee30aa3be62f8250890b8583.svg";
export { ForwardRef as ReactComponent };